export var REMOTE_CONFIG_KEY = /* @__PURE__ */ ((REMOTE_CONFIG_KEY2) => {
  REMOTE_CONFIG_KEY2["OUT_OF_SERVICE_HOSTS"] = "out_of_service_hosts";
  return REMOTE_CONFIG_KEY2;
})(REMOTE_CONFIG_KEY || {});
